<script>
export default {
    translate25Context: 'troubleshooting',
    props: ["component"],
    computed: {
        status() {
            if (!this.component?.country) {
                return 'unknown';
            }
            if (this.component.expected) {
                if (Array.isArray(this.component.expected)) {
                    return this.component.expected.includes(this.component.country) ? 'ok' : 'ko';
                }
                return this.component.country === this.component.expected ? 'ok' : 'ko';
            }
            if (Array.isArray(this.component.exclude)) {
                return this.component.exclude.includes(this.component.country) ? 'ko' : 'ok';
            }
            return 'unknown';
        },
        label() {
            return this.component?.country || this.$vt('Unknown');
        },
    },
};
</script>

<template>
    <div class="troubleshooting-geographic-zone">
        <troubleshooting-page-status :status="status">
            <template #content>{{ label }}</template>
        </troubleshooting-page-status>
    </div>
</template>

<style lang="scss">
.troubleshooting-geographic-zone {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>
